import { Flex, Image } from "@chakra-ui/react";
import React from "react";

const AuthLayout = ({ children }) => {
	return (
		<Flex
			w="100vw"
			h="100vh"
			// justifyContent="center"
			flexDir="column"
			alignItems="center"
			bgGradient="linear(to-r, blue.100, blue.400)">
			<Image src="/ripik_trademark_logo.png" />
			{children}
		</Flex>
	);
};

export default AuthLayout;
